export default "__VITE_ASSET__B5OF14eL__"